import NotesList from "../../../../content/blog/using-keys-in-react/NotesList";
import * as React from 'react';
export default {
  NotesList,
  React
};